import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

async function fetchCurrentDeclarations(token, ids) {
  const hasIds = Array.isArray(ids) && ids.length > 0;
  const { data } = await axios.get(
    `${process.env.REACT_APP_ENDPOINT}/api/drought-declaration/current`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: hasIds ? { ids: ids.join(",") } : undefined,
    }
  );
  return data;
}

export function useCurrentDroughtDeclarations(ids = []) {
  const { getAccessTokenSilently } = useAuth0();
  const keyIds = Array.isArray(ids) ? [...ids].sort().join(",") : "";

  return useQuery(["current", keyIds], async () => {
    const token = await getAccessTokenSilently();
    return fetchCurrentDeclarations(token, Array.isArray(ids) ? ids : []);
  });
}
